import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { listUsers, setUserPro } from '../../lib/api/adminApi';
import { getStoredSteamId } from '../../lib/api/billingApi';

// Interrupteur DEV : l'admin choisit un utilisateur (menu) et active/désactive son Pro.
function AdminProToggle({ onAuthError }) {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState('');
  const [busy, setBusy] = useState(false);

  const loadUsers = () => {
    listUsers()
      .then(({ data }) => {
        setUsers(data);
        const inList = (id) => id && data.some((u) => u.steamId === id);
        setSelected((cur) => {
          if (inList(cur)) return cur;
          // Priorité : le SteamID admin défini en config (REACT_APP_ADMIN_STEAMID).
          const preferred = process.env.REACT_APP_ADMIN_STEAMID;
          if (inList(preferred)) return preferred;
          const remembered = localStorage.getItem('kmg_admin_pro_user'); // dernier choix admin
          if (inList(remembered)) return remembered;
          // Sinon : le compte de test dédié (créé au démarrage).
          const testAcc = data.find((u) => u.email === 'test@keepmygames.com');
          if (testAcc) return testAcc.steamId;
          const stored = getStoredSteamId();
          if (inList(stored)) return stored;
          const withEmail = data.find((u) => u.email);
          return (withEmail || data[0])?.steamId || '';
        });
      })
      .catch((e) => {
        if (onAuthError) onAuthError(e);
      });
  };

  const selectUser = (id) => {
    setSelected(id);
    localStorage.setItem('kmg_admin_pro_user', id); // mémorise pour la prochaine fois
  };

  useEffect(() => {
    loadUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const current = users.find((u) => u.steamId === selected);
  const isPro = !!current?.isPro;

  const toggle = () => {
    if (!selected) return;
    setBusy(true);
    setUserPro(selected, !isPro)
      .then(() => {
        setUsers((us) =>
          us.map((u) => (u.steamId === selected ? { ...u, isPro: !isPro } : u))
        );
      })
      .catch((e) => {
        if (onAuthError) onAuthError(e);
      })
      .finally(() => setBusy(false));
  };

  return (
    <div className="admin-dev">
      <span className="admin-dev__label">{t('admin.dev_pro')}</span>
      {users.length === 0 ? (
        <span className="admin-dev__empty">{t('admin.dev_no_users')}</span>
      ) : (
        <>
          <select
            className="admin-dev__select"
            value={selected}
            onChange={(e) => selectUser(e.target.value)}
          >
            {users.map((u) => (
              <option key={u.steamId} value={u.steamId}>
                {(u.email || u.steamId) + (u.isPro ? ' · PRO' : '')}
              </option>
            ))}
          </select>
          <span className={`admin-dev__status ${isPro ? 'is-pro' : ''}`}>
            {isPro ? 'PRO' : 'FREE'}
          </span>
          <button
            type="button"
            className={`admin-dev__btn ${isPro ? 'is-on' : ''}`}
            onClick={toggle}
            disabled={busy}
          >
            {busy ? '…' : isPro ? t('admin.dev_disable') : t('admin.dev_enable')}
          </button>
        </>
      )}
    </div>
  );
}

export default AdminProToggle;
